import { BehaviorSubject } from 'rxjs';
import Timeline from './Timeline';

let timeline: Timeline = null;
const timeline$ = new BehaviorSubject<Timeline>(null);

// GETTERS

export const GET_TIMELINE = (): Timeline => timeline;

export const GET_TIMELINE$ = (): BehaviorSubject<Timeline> => timeline$;

// SETTERS

export const SET_TIMELINE = (_timeline: Timeline): void => {
  timeline = _timeline;
  timeline$.next(_timeline);
};

// CLEAR

export const CLEAR_TIMELINE = (): void => {
  timeline = null;
  timeline$.next(null);
};
